import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  SimpleGrid,
  Table,
  Tbody,
  Td,
  Button,
  Text,
  Tr,
  useDisclosure,
  HStack,
} from "@chakra-ui/react";
import urlToId from "../../../../helpers/UrlToId";
import Link from "../../../../components/Link";
import PhoneNumber from "../../../../components/buttons/PhoneNumber";
import CreateCustomerModal from "../CustomerCreate";
import { AddIcon } from "@chakra-ui/icons";
import CustomerListFilterBar from "./CustomerFilterBar";
import { useTranslation } from 'react-i18next';
import Pagination from "../../../../components/pagination/Pagination";
import { useLocation, useNavigate } from "react-router-dom";

export default function CustomerListCardView({ customers }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const cardColor = "gray.200";
  const tableColor = "gray.700";
  const createCustomerModalDisclosure = useDisclosure();
  const initialItems = Array.isArray(customers) ? customers : (customers?.results || []);
  const [items, setItems] = useState(initialItems);
  const [currentPage, setCurrentPage] = useState(Array.isArray(customers) ? 1 : (customers?.current_page || 1));
  const [numOfPages, setNumOfPages] = useState(Array.isArray(customers) ? 1 : (customers?.num_of_pages || 1));
  const [pageSize, setPageSize] = useState(Array.isArray(customers) ? customers.length : (customers?.page_size || 20));
  const [totalItems, setTotalItems] = useState(Array.isArray(customers) ? customers.length : (customers?.num_of_items || initialItems.length));

  useEffect(() => {
    const nextItems = Array.isArray(customers) ? customers : (customers?.results || []);
    setItems(nextItems);
    setCurrentPage(Array.isArray(customers) ? 1 : (customers?.current_page || 1));
    setNumOfPages(Array.isArray(customers) ? 1 : (customers?.num_of_pages || 1));
    setPageSize(Array.isArray(customers) ? customers.length : (customers?.page_size || 20));
    setTotalItems(Array.isArray(customers) ? customers.length : (customers?.num_of_items || nextItems.length));
  }, [customers]);

  return (
    <>
      <CreateCustomerModal disclosure={createCustomerModalDisclosure} />
      <Box>
        <CustomerListFilterBar / >
        <Button
          width={"full"}
          onClick={createCustomerModalDisclosure.onOpen}
          rightIcon={<AddIcon />}
          colorScheme="gray"
          variant="solid"
        >
          {t('customer.new_customer')}
        </Button>
      </Box>
      {items.map((customer) => (
        <SimpleGrid
          key={customer.url}
          columns={{ base: 1, sm: 2, md: 2, lg: 2, xl: 5 }}
        >
          <Flex
            maxWidth={"500px"}
            key={customer.id}
            width="100%"
            backgroundClip="border-box"
            bg={cardColor}
            borderColor={"gray:700"}
            borderWidth={2}
            borderBottomWidth={6}
            borderRadius="15px"
            p="1.5rem"
            my="1rem"
          >
            <Box display="flex" flexDirection="column" width="100%">
              <Table
                mt={3}
                size="sm"
                variant="striped"
                colorScheme="blackAlpha"
              >
                <Tbody>
                  <Tr>
                    <Td
                      pl={0}
                      color={tableColor}
                      fontSize="sm"
                      fontWeight="semibold"
                    >
                      {t('customer.customer')}:
                    </Td>
                    <Td pl={0} color={tableColor}>
                      <Link to={`/musteriler/${urlToId(customer.url)}`}>
                        <Text as="b">{`${customer.user.first_name} ${customer.user.last_name}`}</Text>
                      </Link>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td
                      pl={0}
                      color={tableColor}
                      fontSize="sm"
                      fontWeight="semibold"
                    >
                      {t('customer.city')}:
                    </Td>
                    <Td pl={0} color={tableColor}>
                      {customer.city_name}
                    </Td>
                  </Tr>
                  <Tr>
                    <Td
                      pl={0}
                      color={tableColor}
                      fontSize="sm"
                      fontWeight="semibold"
                    >
                      {t('customer.phone')}:
                    </Td>
                    <Td pl={0} color={tableColor}>
                      <PhoneNumber number={customer.phone_number} />
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          </Flex>
        </SimpleGrid>
      ))}
      <Box mt={4}>
        <Pagination
          path={"musteriler"}
          num_of_items={totalItems}
          num_of_pages={numOfPages}
          currentPage={currentPage}
          onPageChange={(p) => {
            const params = new URLSearchParams(location.search);
            if (p && p > 1) params.set("page", String(p));
            else params.delete("page");
            const qs = params.toString();
            navigate({ pathname: "/musteriler/", search: qs ? `?${qs}` : "" });
          }}
        />
      </Box>
    </>
  );
}
